import { useFormContext } from "react-hook-form";
import { Button } from "@mantine/core";
import { usePostApi } from "../../../../hooks";
import { useState } from "react";
import { getYachtId } from "../../../../utils";
import { Notification } from "src/utils/Notification";

interface Props {
  refetch: () => void;
}
const NMEASaveButton = ({ refetch }: Props) => {
  const { getValues } = useFormContext();
  const { post } = usePostApi();
  const [loading, setLoading] = useState(false);
  const handleSave = async () => {
    setLoading(true);
    const data = getValues();
    await post({
      request: "save-nmea-config",
      body: {
        params: {
          yachtid: getYachtId(),
          ...data,
        },
      },
      onSuccess: () => {
        Notification("Success", "NMEA settings saved successfully", "green");
      },
    });
    await refetch();
    setLoading(false);
    window.location.reload();
  };
  return (
    <Button onClick={handleSave} loading={loading}>
      Save
    </Button>
  );
};
export default NMEASaveButton;
